import { z } from 'zod';

const paginationOptionsSchema = z.object({
  from: z.number(),
  to: z.number(),
});
type PaginationsOptions = z.infer<typeof paginationOptionsSchema>;

export { paginationOptionsSchema, type PaginationsOptions };
